<template>
    <v-container>
        <v-layout>
            <v-flex>
                <component :is="theComponent" />
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import Login from '../Login/Login';
import Home from '../Home/Home';
export default {
    components: {
        Home,
        Login
    },
    computed: {
        theComponent() {
            return this.$store.getters.authenticated ? Home : Login;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/Main/Main.vue